import { render, staticRenderFns } from "./UserModelPermissions.vue?vue&type=template&id=41633246"
import script from "./UserModelPermissions.js?vue&type=script&lang=js&external"
export * from "./UserModelPermissions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports